module.exports = __webpack_public_path__ + "static/img/indexBtn1.e3a551d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/indexBtn1.jpg
// module id = gxjb
// module chunks = 1